// extracted by mini-css-extract-plugin
export var bodySections = "_be-8";
export var gray = "_be-7";
export var green = "_be-4";
export var iconContainer = "_be-9";
export var iconWidgetContainer = "_be-1";
export var phoneIcon = "_be-2";
export var red = "_be-5";
export var statusDot = "_be-3";
export var widgetContainer = "_be-0";
export var yellow = "_be-6";